import { render, staticRenderFns } from "./SliderArrow.vue?vue&type=template&id=131b6eb3&scoped=true&"
import script from "./SliderArrow.vue?vue&type=script&lang=js&"
export * from "./SliderArrow.vue?vue&type=script&lang=js&"
import style0 from "./SliderArrow.vue?vue&type=style&index=0&id=131b6eb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b6eb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131b6eb3')) {
      api.createRecord('131b6eb3', component.options)
    } else {
      api.reload('131b6eb3', component.options)
    }
    module.hot.accept("./SliderArrow.vue?vue&type=template&id=131b6eb3&scoped=true&", function () {
      api.rerender('131b6eb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/SliderArrow.vue"
export default component.exports